<template>
  <InstagramToolPage
    h1-title="Instagram Reels Downloader"
    subtitle="Save public Instagram Reels to your device using the Reel link."
    input-placeholder="Paste Instagram Reel URL here"
    action-label="Download"
    limitation-note="Public Reels only. Audio depends on what Instagram serves."
    current-tool-path="/instagram-reels-downloader/"
    :faqs="faqs"
  >
    <ToolContentSections :sections="reelsDownloaderSections" />
  </InstagramToolPage>
</template>

<script>
import InstagramToolPage from '@/components/InstagramToolPage.vue';
import ToolContentSections from '@/components/ToolContentSections.vue';
import { reelsDownloaderSections } from '@/data/instagram-tool-page-content';

export default {
  name: 'InstagramReelsDownloaderPage',
  components: { InstagramToolPage, ToolContentSections },
  data () {
    return {
      reelsDownloaderSections,
      faqs: [
        {
          question: 'Which URL format works?',
          answer: 'Links containing instagram.com/reel/ or /reels/ with a short code usually work best. Copy the link directly from the Reel share menu.',
        },
        {
          question: 'Can I download private Reels?',
          answer: 'No. Only public Reels that Instagram still serves for the URL are supported.',
        },
        {
          question: 'Will the downloaded Reel include music?',
          answer: 'Sometimes. Licensed audio may be muted or replaced in the downloaded file depending on Instagram’s rules.',
        },
        {
          question: 'Can I repost a downloaded Reel?',
          answer: 'Reusing someone else’s Reel may require their permission and can involve copyright. Download for personal offline viewing unless you have rights to republish.',
        },
      ],
    };
  },
};
</script>
